import type { ArchiveStreamConfig } from './types';

const CSRF_COOKIE = 'pacebi_csrf';
function csrfToken(): string {
  const m = document.cookie.match(new RegExp('(?:^|; )' + CSRF_COOKIE + '=([^;]+)'));
  return m ? decodeURIComponent(m[1]) : '';
}

export interface ArchiveConfig {
  streams: ArchiveStreamConfig[];
  configured: boolean;
}

export async function fetchArchiveConfig(): Promise<ArchiveConfig> {
  const res = await fetch('/api/archive-config', { credentials: 'same-origin' });
  if (res.status === 403) throw new Error('forbidden');
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as ArchiveConfig;
}

export async function saveArchiveConfig(streams: ArchiveStreamConfig[]): Promise<void> {
  const res = await fetch('/api/archive-config', {
    method: 'PUT',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
    body: JSON.stringify({ streams }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${await res.text()}`);
}
